/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { SearchFilterSizeGenderSelectDesktop } from 'search/components/searchGrid/SearchFilterSizeGenderSelectDesktop';
import { sortConditionTitles, sortGender, sortSizeTitles } from 'search/utils/sizeFilterUtils';
import { ConsumerSearchFilterGrid } from 'search/components/searchGrid/SearchFilterGrid';
import { SIZE_MAP } from 'shared/enums/Size';
import { useLocation } from 'shared/hooks/useLocation';
import { ConsumerSearchFilterConditionOptionDesktop } from 'search/components/searchGrid/SearchFilterConditionOptionDesktop';
import ConsumerSearchFilterPriceDesktop from 'search/components/searchGrid/ConsumerSearchFilterPriceDesktop';
import { useEventContext } from 'tracking/hooks/useEventContext';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { getAppliedFilters } from 'shared/utils/gridEventTrackingUtils';
import {
  CONDITION_DESCRIPTION,
  NAME_DISPLAY,
  QUERY_NAME_DISPLAY,
  SORT_FILTER_MAP,
  TopTitleFilter,
} from './constant';
import Text from '../Text';
import {
  appendZero,
  colorsPalette,
  colorSwatch,
  getSortedFilterList,
  mergeColorsByName,
} from './utils/gridUtils';
import { UnorderedList } from '../UnorderedList';

const ALL_VALID_COUNTRIES = new Set(['US', 'EU', 'FR', 'IT', 'JP', 'UK']);
function isValidSize(numString: string, options: { isApparel: boolean }) {
  const num = Number.parseFloat(numString);

  if (!options?.isApparel && (Number.isNaN(num) || (!Number.isNaN(num) && (num > 25 || num < 0)))) {
    return false;
  }

  return !Number.isNaN(num) && (num % 1 === 0 || num % 1 === 0.5);
}

export const SizeOrder = [
  'xxxs',
  'xxxs/xxs',
  'xxs',
  'xxs/xs',
  'xs',
  'xs/s',
  's',
  's/m',
  'm',
  'm/l',
  'l',
  'l/xl',
  'xl',
  'xl/xxl',
  'xxl',
  'xxl/xxxl',
  'xxxl',
  '4xl',
];

export const sortByShirtSizeOrder = (sizeArray: any[]) => {
  sizeArray.sort((a, b) => {
    if (
      SizeOrder.indexOf(a.display_name?.toLowerCase()) <
      SizeOrder.indexOf(b.display_name?.toLowerCase())
    ) {
      return -1;
    }
    if (
      SizeOrder.indexOf(b.display_name?.toLowerCase()) <
      SizeOrder.indexOf(a.display_name?.toLowerCase())
    ) {
      return 1;
    }
    return 0;
  });
  return sizeArray;
};

export const FilterItem = ({
  name,
  kids,
  onClick,
  isColor,
  isYearsList,
  isRootCategory,
  isProductType,
  isSort,
  sizeList,
  isSizeList,
  isGender,
}: {
  name: string;
  kids?: any[];
  open?: boolean;
  onClick?: (e: any) => void;
  isColor?: string;
  isYearsList?: boolean;
  isProductType?: boolean;
  isActivityType?: boolean;
  isRootCategory?: boolean;
  isSort?: string;
  sizeList?: any[];
  isSizeList?: boolean;
  isGender?: boolean;
}) => {
  const router = useRouter();
  const { selectedCountryCode } = useLocation();
  const eventTrackingEventContext = useEventContext();

  const { query } = router || {};
  const hasKids = kids && kids.length > 0;

  const getDataQa = useCallback(
    (str: string) => {
      // eslint-disable-next-line unicorn/no-useless-undefined
      if (!str) return undefined;

      const t = str.toLowerCase();
      if (isSort) {
        if (t === 'recently released sneakers') {
          return 'recently_released_sneakers_sort_option';
        }

        if (t === 'new in apparel') {
          return 'new_in_apparel_sort_option';
        }

        if (t === 'popular') {
          return 'popular_sort_option';
        }

        if (t === 'price (low - high)') {
          return 'price_low_high_sort_option';
        }
        if (t === 'price (high - low)') {
          return 'price_high_low_sort_option';
        }
        return `${t}_sort_option`;
      }

      return `${t}_filter_option`;
    },
    [isSort],
  );
  const genders = sizeList
    ?.map((item) => item?.name?.split('_')?.[1]?.trim?.() || '')
    .filter((i) => i)
    .sort(sortGender);
  const [selectedGender, setSelectedGender] = useState(0);

  const handleSelectChange = useCallback((value) => {
    setSelectedGender(genders.indexOf(value));
  }, []);

  const sizeGridData = useCallback(() => {
    const sizeListOptions = sizeList?.find(
      (s) => genders?.[selectedGender] === s?.name?.split('_')?.[1]?.trim?.() || '',
    );

    const country = ALL_VALID_COUNTRIES.has(selectedCountryCode.toUpperCase())
      ? selectedCountryCode.toUpperCase()
      : 'US';

    let allOptions = sizeListOptions?.availableSizesList?.map((item) => {
      const optValue = `${name === 'shoes' ? `${country}_` : 'universal_'}${name === 'shoes' ? 'sneakers' : name}_${genders?.[selectedGender]}_${SIZE_MAP[item.name] || item.name}`;
      return {
        value: optValue,
        status: new Set(((query.sizes || '') as string).split(',')).has(optValue) ? 'selected' : '',
        display_name: (SIZE_MAP[item.name] || appendZero(item.name)).toUpperCase(),
      };
    });

    allOptions =
      name === 'shoes'
        ? allOptions
            .filter((a) => isValidSize(a.display_name, { isApparel: false }))
            .sort((a, b) => a.display_name - b.display_name)
        : sortByShirtSizeOrder(
            allOptions.filter((a) =>
              Object.values(SIZE_MAP).includes(a.display_name?.toLowerCase()),
            ) || [],
          );

    return allOptions;
  }, [genders, name, selectedGender, sizeList, selectedCountryCode]);

  const queryName: any = isGender
    ? 'genders'
    : isProductType
      ? 'types'
      : !isRootCategory
        ? 'activities'
        : isYearsList
          ? 'releaseYears'
          : 'categories';

  const selectedTypes = new Set(((query[queryName] || '') as string).split(','));

  //  check the sortType to selec
  let selectedSort = isSort;
  const categoriesNow = ((query.categories as string) || '')?.trim() || '';
  const typesNow = ((query.types as string) || '')?.trim() || '';
  if (categoriesNow === 'Apparel' && query.sortType === 'recently_released') {
    selectedSort = 'new_in_apparel';
  } else if (
    query.sortType === 'recently_released' &&
    typesNow === 'sneakers' &&
    categoriesNow === 'shoes'
  ) {
    selectedSort = 'recently_released_sneakers';
  } else {
    selectedSort = query.sortType as string;
  }

  const isSelected = isSort ? selectedSort === isSort : selectedTypes.has(name);
  const [open, setOpen] = useState(!isSort ? isSelected : false);

  useEffect(() => {
    setOpen(!isSort ? isSelected : false);
  }, [isSelected, isSort]);

  if (isColor && !colorsPalette.includes(isColor)) {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={(e) => {
        if (isSizeList) {
          setOpen((p) => !p);
        } else {
          onClick?.(e);
        }
      }}
      style={{
        marginBottom: isProductType && open ? '16px' : '0px',
      }}
      className={isSort ? 'hover:underline underline-offset-2 ' : ''}
    >
      <div
        className="mb-1 underline-offset-2 cursor-pointer"
        style={{
          textDecoration:
            open || isSelected || (!selectedSort && isSort === 'popular') ? 'underline' : 'none',
          textAlign: 'right',
          marginBottom: isColor ? '0px' : '',
        }}
      >
        <div
          className="flex items-center gap-0"
          style={{
            justifyContent: isYearsList ? 'normal' : 'end',
            overflowWrap: 'anywhere',
          }}
        >
          {isColor && colorsPalette.includes(isColor) ? (
            <div className="flex items-center gap-2 group">
              <Text
                className="hidden group group-hover:block"
                as="button"
                style={{
                  display: isSelected ? 'block' : '',
                  textTransform: 'capitalize',
                }}
              >
                {isColor}
              </Text>
              <div
                className="w-[20px] h-[20px]"
                style={{
                  backgroundColor: colorSwatch[isColor] || isColor,
                  backgroundImage:
                    isColor === 'multi-color'
                      ? 'url("https://cms-cdn.goat.com/750/567e15a619be-4918-ce11-49d1-06ca4b9e.png")'
                      : 'none',
                  backgroundSize: 'contain',
                }}
              />
            </div>
          ) : (
            <Text
              className="first-letter:uppercase"
              as="button"
              style={{
                fontWeight: isSelected && !isSort && !isGender ? 'bold' : 'normal',
              }}
              data-qa={getDataQa(name)}
            >
              {isSizeList && name === 'shoes' ? 'Sneakers' : name}
            </Text>
          )}
        </div>
      </div>
      {/* SIZE DROPDOWNS HERE */}
      {open && isSizeList && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            flexDirection: 'column',
            alignItems: 'end',
            paddingBottom: '32px',
          }}
        >
          <SearchFilterSizeGenderSelectDesktop
            options={genders}
            handleSelectChange={handleSelectChange}
            selectedGender={genders?.[selectedGender]}
          />
          <ConsumerSearchFilterGrid
            filterOptions={sizeGridData()}
            name="size_converted"
            handleClick={(value) => {
              let newQuery: any = { ...query };
              const selectedSizes = new Set(((query.sizes || '') as string).split(','));

              const newTypes = new Set(selectedSizes);
              if (newTypes.has(value as string)) {
                newTypes.delete(value as string);
              } else {
                newTypes.add(value as string);
              }
              newQuery = {
                ...newQuery,
                sizes: [...newTypes].join(','),
              };

              void router.push(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                `${window.location.pathname}?${new URLSearchParams(newQuery).toString()}`,
              );
            }}
          />
        </div>
      )}

      {/* EVERY OTHER DROPDOWN HERE */}

      {open &&
        hasKids &&
        kids.map((kid) => {
          // eslint-disable-next-line no-extra-boolean-cast, @typescript-eslint/no-shadow
          const queryName = Boolean(kid.activitiesList)
            ? 'types'
            : !isRootCategory
              ? 'activities'
              : 'categories';

          // eslint-disable-next-line @typescript-eslint/no-shadow
          const selectedTypes = new Set(((query[queryName] || '') as string).split(','));
          return (
            <FilterItem
              key={kid.name || 'kid'}
              name={kid.name}
              kids={kid.activitiesList}
              isActivityType={!isRootCategory && isProductType && !kid.activitiesList}
              isProductType={Boolean(kid.activitiesList)}
              onClick={(e) => {
                let newQuery: any = { ...query };
                e.preventDefault();
                e.stopPropagation();
                const newTypes = new Set(selectedTypes);
                if (newTypes.has(kid.name)) {
                  newTypes.delete(kid.name);
                  // if it's type, delete all activities associated with it
                  if (kid.activitiesList) {
                    const allkidsSet = new Set(((query.activities || '') as string).split(','));

                    kid.activitiesList.forEach((activity: any) => {
                      allkidsSet.delete(activity.name);
                    });

                    newQuery = {
                      ...newQuery,
                      activities: [...allkidsSet].join(',') as string,
                    };
                  }
                } else {
                  newTypes.add(kid.name);
                }
                newQuery = {
                  ...newQuery,
                  [queryName]: [...newTypes].join(',') as string,
                };

                sendTrackingEvent('FILTER_APPLY_TAP', {
                  event_context: eventTrackingEventContext,
                  filter_name: queryName,
                  filter_selection: kid.name,
                  ...(getAppliedFilters(newQuery) && {
                    applied_filters: getAppliedFilters(newQuery),
                  }),
                  ...(query?.query && { search_string: query.query.toString() }),
                });

                void router.push(
                  `${window.location.pathname}?${new URLSearchParams(newQuery).toString()}`,
                );
              }}
            />
          );
        })}
    </div>
  );
};

export const DesktopFilterSidebar = ({
  resetQuery,
  onSelectSection,
  sideBarState,
  filters,
}: {
  filters?: any;
  resetQuery?: () => void;
  onSelectSection: (newState: any) => void;
  sideBarState: any;
  collectionDetails?: any;
}) => {
  const router = useRouter();
  const { query } = router || {};
  const { selectedCountryCode } = useLocation();
  const eventTrackingEventContext = useEventContext();

  const hasNoQuery = useCallback(
    () =>
      Object.keys(query || {}).filter((q) => q !== 'query' && q !== 'pageNumber' && q !== 'slug')
        .length === 0,
    [query],
  );

  const sortedFilterList = useCallback(
    (title) => {
      return getSortedFilterList(filters[title], title);
    },
    [filters],
  );

  const getQaData = useCallback((str: string) => {
    // eslint-disable-next-line unicorn/no-useless-undefined
    if (!str) return undefined;

    const t = str.toLowerCase();
    if (t === 'instant') {
      return `instant_ship_filter_option`;
    }

    if (t === 'under retail') {
      return `under_retail_filter_option`;
    }

    if (t === 'available now') {
      return `available_now_filter_option`;
    }
    return `${t}_filter_option`;
  }, []);

  // New taxonomy

  const hasApparels = useCallback(() => {
    const apparel =
      filters?.productCategoriesList?.some((category: any) => category.name === 'Apparel') ||
      (query?.categories || '')?.length === 0 ||
      query?.categories?.includes('Apparel');
    return apparel;
  }, [query, filters]);

  const hasSneakers = useCallback(() => {
    const sneakers =
      filters?.productCategoriesList?.some((category: any) => category.name === 'Footwear') ||
      (query?.categories || '')?.length === 0 ||
      (query?.categories?.includes('Footwear') && (query?.types || '').length === 0) ||
      query?.types?.includes('sneakers');

    return sneakers;
  }, [query, filters]);

  return (
    <div className="pt-[78px] pr-4 pb-[160px] overflow-scroll no-scrollbar " id="sidebar">
      {/* sort first */}
      <div className="pb-6">
        {Object.keys(SORT_FILTER_MAP).map((sort: string) => {
          if (
            (sort === 'new_in_apparel' && !hasApparels()) ||
            (sort === 'recently_released_sneakers' && !hasSneakers())
          ) {
            return null;
          }
          return (
            <FilterItem
              key={sort}
              name={SORT_FILTER_MAP[sort].name}
              isSort={sort}
              onClick={() => {
                let newQuery = {};

                if (sort === 'new_in_apparel') {
                  newQuery = {
                    categories: 'Apparel',
                    sortType: 'recently_released',
                    pageNumber: 1,
                  };
                } else if (sort === 'recently_released_sneakers') {
                  newQuery = {
                    types: 'sneakers',
                    categories: 'shoes',
                    sortType: 'recently_released',
                    pageNumber: 1,
                  };
                } else {
                  newQuery = {
                    ...query,
                    sortType: sort,
                  };
                }
                sendTrackingEvent('FILTER_SORT_TAP', {
                  event_context: eventTrackingEventContext,
                  sort_selection: sort,
                });
                void router.push(
                  `${window.location.pathname}?${new URLSearchParams(newQuery).toString()}`,
                );
              }}
            />
          );
        })}
      </div>

      {/* space to reset */}
      <div
        className="mb-5 text-right cursor-pointer hover:underline"
        onClick={() => {
          if (!hasNoQuery()) {
            resetQuery?.();
          }
        }}
        data-qa={hasNoQuery() ? '' : 'clear-filters'}
      >
        {hasNoQuery() ? '' : 'Reset'}
      </div>

      {/* brand category gender year */}

      {Object.keys(NAME_DISPLAY).map((topTitle: string) => {
        let currentFilters = sortedFilterList(topTitle);

        // get query name eg: brands for brandsList
        const queryName = QUERY_NAME_DISPLAY[topTitle as TopTitleFilter] || topTitle;

        const isYearsList = queryName === 'releaseYears';
        const isSizeList = queryName === 'size';
        const isConditionList = queryName === 'conditions';
        const isPrice = topTitle === 'price';
        const isColorList = queryName === 'colors';

        const isBooleanTilte = ['instantShip', 'underRetail', 'inStock', 'sale'].includes(topTitle);

        if (isSizeList) {
          currentFilters = currentFilters
            ?.filter((size) => {
              const sizeUnit = size?.gendersList?.[0]?.name?.split('_')?.[0]?.trim?.();

              const currentUnit = ALL_VALID_COUNTRIES.has(selectedCountryCode.toUpperCase())
                ? selectedCountryCode.toUpperCase()
                : 'US';
              return (
                ['shoes', 'tops', 'bottoms', 'outerwear', 'dresses', 'belts'].includes(
                  ((size.name as string) || '')?.toLowerCase(),
                ) &&
                ((size.name === 'shoes' && currentUnit === sizeUnit) || sizeUnit === 'UNIVERSAL')
              );
            })
            .sort(sortSizeTitles);
        } else if (isConditionList) {
          currentFilters = currentFilters.sort(sortConditionTitles);
        } else if (isColorList) {
          currentFilters = mergeColorsByName([...(currentFilters || [])]);
        }

        const selectedTypes = new Set(((query[queryName] || '') as string).split(','));
        if (!currentFilters) {
          return null;
        }
        if (
          isBooleanTilte &&
          (((topTitle === 'instantShip' || topTitle === 'underRetail') && !filters?.[topTitle]) ||
            (!hasApparels() && topTitle === 'sale'))
        )
          return null;

        return (
          <div className="text-right" key={topTitle}>
            <div
              className="underline-offset-2 cursor-pointer hover:underline"
              onClick={() => {
                if (!sideBarState[topTitle] && !isBooleanTilte) {
                  sendTrackingEvent('FILTER_EXPAND_TAP', {
                    event_context: eventTrackingEventContext,
                    filter_name:
                      NAME_DISPLAY[topTitle as TopTitleFilter].toLowerCase() === 'category'
                        ? 'web_groups'
                        : NAME_DISPLAY[topTitle as TopTitleFilter].toLowerCase(),
                    ...(query?.query && { search_string: query.query.toString() }),
                  });
                }
                onSelectSection({
                  ...sideBarState,
                  [topTitle]: !sideBarState[topTitle],
                });
                if (isBooleanTilte) {
                  const newQuery: any = { ...query };

                  if (newQuery[topTitle] === 'true') {
                    delete newQuery[topTitle];
                  } else {
                    newQuery[topTitle] = 'true';
                  }

                  sendTrackingEvent('FILTER_APPLY_TAP', {
                    event_context: eventTrackingEventContext,
                    filter_name: topTitle,
                    filter_selection: newQuery[topTitle],
                    ...(getAppliedFilters(newQuery) && {
                      applied_filters: getAppliedFilters(newQuery),
                    }),
                    ...(newQuery?.query && { search_string: newQuery.query.toString() }),
                  });

                  void router.push(
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    `${window.location.pathname}?${new URLSearchParams(newQuery).toString()}`,
                  );
                }
              }}
            >
              {!isPrice ? (
                <Text
                  className="capitalize pb-1 cursor-pointer hover:underline"
                  style={{
                    textDecoration:
                      sideBarState[topTitle] || query[queryName] ? 'underline' : 'none',
                  }}
                  as="button"
                  data-qa={getQaData(NAME_DISPLAY[topTitle as TopTitleFilter].toLowerCase())}
                >
                  {NAME_DISPLAY[topTitle as TopTitleFilter]}
                </Text>
              ) : (
                <ConsumerSearchFilterPriceDesktop
                  name="price"
                  priceMax={filters?.maximumPriceCents?.amountCents || 0}
                  priceMin={filters?.minimumPriceCents?.amountCents || 0}
                  displayName="Price"
                />
              )}
            </div>
            {sideBarState[topTitle] &&
              !isBooleanTilte &&
              !isPrice &&
              (isConditionList ? (
                <UnorderedList
                  data-qa="search_filter_conditions_list"
                  style={{
                    marginBottom: 16,
                  }}
                >
                  {currentFilters.map((option) => (
                    <ConsumerSearchFilterConditionOptionDesktop
                      key={option.name}
                      handleClick={(value) => {
                        let newQuery: any = { ...query };
                        const selectedConditions = new Set(
                          ((query.conditions || '') as string).split(','),
                        );

                        const newTypes = new Set(selectedConditions);
                        if (newTypes.has(value as string)) {
                          newTypes.delete(value as string);
                        } else {
                          newTypes.add(value as string);
                        }
                        newQuery = {
                          ...newQuery,
                          conditions: [...newTypes].join(','),
                        };

                        void router.push(
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                          `${window.location.pathname}?${new URLSearchParams(newQuery).toString()}`,
                        );
                      }}
                      facetType="product_condition"
                      option={{
                        status: new Set(((query.conditions || '') as string).split(',')).has(
                          option.name,
                        )
                          ? 'selected'
                          : '',
                        value: option.name,
                        ...CONDITION_DESCRIPTION[option.name],
                      }}
                    />
                  ))}
                </UnorderedList>
              ) : (
                <div
                  className="mb-4 max-h-[180px] overflow-y-scroll no-scrollbar flex flex-col "
                  style={{
                    borderBottom: currentFilters.length > 10 ? '1px solid #000' : 'none',
                    maxHeight: isYearsList
                      ? 'none'
                      : topTitle === 'productCategoriesList' || topTitle === 'sizesList'
                        ? '100%'
                        : '180px',
                    gap: isYearsList ? 4 : 0,
                    gridTemplateColumns: isYearsList ? 'repeat(3, 1fr)' : '',
                    marginTop: isYearsList ? 4 : '',
                    direction: isYearsList ? 'rtl' : 'ltr',
                    display: isYearsList ? 'grid' : 'block',
                  }}
                >
                  {currentFilters &&
                    currentFilters.map(
                      (productType: {
                        name: string;
                        gendersList?: any[];
                        productTypesList?: any[];
                        activitiesList?: any[];
                      }) => {
                        return (
                          <FilterItem
                            name={productType.name}
                            key={productType.name}
                            isGender={topTitle === 'gendersList'}
                            isColor={topTitle === 'colorsList' ? productType.name : undefined}
                            kids={
                              topTitle === 'productCategoriesList'
                                ? productType.productTypesList || productType.activitiesList
                                : undefined
                            }
                            sizeList={productType.gendersList || []}
                            isYearsList={isYearsList}
                            isSizeList={isSizeList}
                            isRootCategory
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (isSizeList) return;
                              let newQuery: any = { ...query, pageNumber: 1 };
                              const newTypes = new Set(selectedTypes);
                              if (newTypes.has(productType.name)) {
                                newTypes.delete(productType.name);
                                // since it's root category delete all types associated with it
                                if (productType.productTypesList) {
                                  const allkidsSet = new Set(
                                    ((query.types || '') as string).split(','),
                                  );

                                  productType.productTypesList.forEach((activity: any) => {
                                    allkidsSet.delete(activity.name);
                                  });

                                  newQuery = {
                                    ...newQuery,
                                    types: [...allkidsSet].join(',') as string,
                                  };
                                }
                              } else {
                                newTypes.add(productType.name);
                              }

                              newQuery = {
                                ...newQuery,
                                [queryName]: [...newTypes].join(',') as string,
                              };

                              sendTrackingEvent('FILTER_APPLY_TAP', {
                                event_context: eventTrackingEventContext,
                                filter_name: queryName,
                                filter_selection: productType.name,
                                ...(getAppliedFilters(newQuery) && {
                                  applied_filters: getAppliedFilters(newQuery),
                                }),
                                ...(query?.query && { search_string: query.query.toString() }),
                              });

                              void router.push(
                                `${window.location.pathname}?${new URLSearchParams(
                                  newQuery,
                                ).toString()}`,
                              );
                            }}
                          />
                        );
                      },
                    )}
                </div>
              ))}
          </div>
        );
      })}
    </div>
  );
};
